import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import {PopUpContext} from "../../contexts/popUpContext";

class StudentPersonalInfoForm extends Form {
    static contextType = PopUpContext;

    state = {
        drp: {
            city: [],
            supporter: [],
        },
        data: {
            grand_father_name: "",
            grand_father_name_en: "",
            mother_name: null,
            mother_name_en: null,
            tazkera_no: null,
            current_address_city_id: null,
            current_address: null,
            permanent_address_city_id: null,
            permanent_address: null,
            supporter_id: null,
            parent_phone: null,
            parent_job: null,
        },
        errors: {},
    };

    componentDidMount = async () => {
        const {drp, data} = this.state;
        const {
            popUp: {cache, edit},
        } = this.context;

        if (edit) {
            data.grand_father_name = edit.grand_father_name;
            data.grand_father_name_en = edit.grand_father_name_en;
            data.mother_name = edit.mother_name;
            data.mother_name_en = edit.mother_name_en;
            data.tazkera_no = edit.tazkera_no;
            data.current_address_city_id = edit.current_address_city_id;
            data.current_address = edit.current_address;
            data.permanent_address_city_id = edit.permanent_address_city_id;
            data.permanent_address = edit.permanent_address;
            data.supporter_id = edit.supporter_id;
            data.parent_phone = edit.parent_phone;
            data.parent_job = edit.parent_job;
        }

        await db
            .getAll(`dropdowns/cities`)
            .then(({data: {data}}) => (drp["city"] = data));

        await db
            .getAll(`dropdowns/studentSupporters`)
            .then(({data: {data}}) => (drp["supporter"] = data));

        this.setState({drp, data});
    };

    schema = {
        grand_father_name: Joi.string().max(64),
        grand_father_name_en: Joi.string().max(64),
        mother_name: Joi.string().max(64).allow(null).allow(''),
        mother_name_en: Joi.string().max(64).allow(null).allow(''),
        tazkera_no: Joi.string().max(20).allow(null).allow(''),
        current_address_city_id: Joi.number().allow(null).allow(''),
        current_address: Joi.string().max(128).allow(null).allow(''),
        permanent_address_city_id: Joi.number().allow(null).allow(''),
        permanent_address: Joi.string().max(128).allow(null).allow(''),
        supporter_id: Joi.number().allow(null).allow(''),
        parent_phone: Joi.string().max(12).allow(null).allow(''),
        parent_job: Joi.string().max(64).allow(null).allow(''),
    };

    doSubmit = async (e) => {
        const {togglePopUp, popUp} = this.context;
        const student_id = popUp.student.student_id;

        let __controls = this.cleanObject({
            student_id: popUp?.cache,
            ...this.state.data,
        });

        try {
            if (popUp?.edit?.id) {
                await db
                    .edit(`students/${student_id}/info/${popUp.edit.id}`, __controls)
                    .then(() => {
                        togglePopUp({ form: "toast" });
                    })
                    .catch((e) => {
                        togglePopUp({
                            form: "toast",
                            message: e.toString(),
                            type: "warning",
                        });
                    });
            } else {
                await db
                    .save(`students/${student_id}/info`, __controls)
                    .then(() => {
                        togglePopUp({ form: "toast" });
                    })
                    .catch((e) => {
                        togglePopUp({
                            form: "toast",
                            message: e.toString(),
                            type: "warning",
                        });
                    });
            }
            if (popUp.callback) popUp.callback();

        } catch ({response}) {
            if (response && response.status === 400) {
                const errors = {...this.state.error};

                this.setState({errors});
            }
        }
    };

    render() {
        const {data, drp} = this.state;
        const {popUp} = this.context;

        console.log(this.state)

        return (
            <div className="form-container">
                <form className="form crud" onSubmit={this.handleSubmit}>
                    <div className="head">
                        <p>{popUp?.edit ? lbl.EditStudentPersonalInfo : lbl.AddStudentPersonalInfo}</p>
                    </div>
                    <div className="form-inputs">
                        <div className="multi-input">
                            {this.renderInput("grand_father_name", "اسم پدر کلان", "text")}
                            <div className="pad"/>
                            {this.renderInput("grand_father_name_en", "Grandfather Name", "text")}
                        </div>
                        <div className="multi-input">
                            {this.renderInput("mother_name", "اسم مادر", "text")}
                            <div className="pad"/>
                            {this.renderInput("mother_name_en", "Mother Name", "text")}
                        </div>
                        <div className="multi-input">
                            {this.renderSelect("current_address_city_id", "آدرس سکونت فعلی", drp["city"])}
                            <div className="pad"/>
                            {this.renderInput("current_address", "سکونت فعلی", "text")}
                        </div>
                        <div className="multi-input">
                            {this.renderSelect("permanent_address_city_id", "سکونت اصلی", drp["city"])}
                            <div className="pad"/>
                            {this.renderInput("permanent_address", "آدرس سکونت اصلی", "text")}
                        </div>
                        <div className="multi-input">
                            {this.renderSelect("supporter_id", "همابت کننده مالی", drp["supporter"])}
                            <div className="pad"/>
                            {this.renderInput("parent_phone", "شماره تماس پدر/مادر", "text")}
                        </div>
                        <div className="multi-input">
                            {this.renderInput("parent_job", "شغل پدر/مادر", "text")}
                            <div className="pad"/>
                            {this.renderInput("tazkera_no", "شماره تذکره", "text")}
                        </div>
                    </div>
                    <div className="form-buttons">
                        {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
                    </div>
                </form>
            </div>
        );
    }
}

export default StudentPersonalInfoForm;
